/**
 * Chart data refresh functionality
 */

import { fetchData } from '../api.js';
import { addCircleLabels } from '../labels.js';
import { restoreHighlights } from '../search.js';
import { populateRoleMap } from '../panel/utils.js';
import type { CirclePackChart } from '../../shared/types.js';

/**
 * Create chart refresh function
 */
export function createRefreshChart(chart: CirclePackChart): () => Promise<void> {
    return async function refreshChart() {
        try {
            const updatedData = await fetchData();
            if (updatedData) {
                // Update global roleMap with current role names
                const dataArray = Array.isArray(updatedData) ? updatedData : [updatedData];
                populateRoleMap(dataArray);
                
                // Force complete re-render by clearing and resetting data
                chart.data(null);
                setTimeout(() => {
                    chart.data(updatedData);
                    setTimeout(() => {
                        addCircleLabels();
                        restoreHighlights();
                    }, 150);
                }, 50);
            }
        } catch (error) {
            console.error('Error refreshing chart:', error);
        }
    };
}
